import { ActionType } from "../actions/actionTypes";

type PolicyState = {
  policy?: Policy;
  policyCustomer?: Customer;
  policyTasks?: Task[];
  policyBilling?: AccountInquiryDTO;
  error?: any;
  loading: boolean;
};

const INITIAL_STATE = {
  loading: false
};

export default (
  state: PolicyState = INITIAL_STATE,
  action: ActionType
): PolicyState => {
  switch (action.type) {
    case "POLICY_REQUEST": {
      return { ...state, error: null, loading: true };
    }
    case "POLICY_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "POLICY_TASK_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "POLICY_BILLING_SUCCESS": {
      return { ...state, error: null, ...action.payload, loading: false };
    }
    case "POLICY_FAILURE": {
      return { ...state, ...action.payload, loading: false };
    }
    default:
      return state;
  }
};
